import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, HostListener, Inject, Input, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as Hammer from 'hammerjs';
import { BookImage, BookImageType, BookPage, BookPageType } from 'src/app/data/book';
import { GlobalVariables } from 'src/app/data/global-variables';
import { TokenPermissions } from 'src/app/data/permissions';
import { FloatingVisorComponent } from 'src/app/floating-visor/floating-visor.component';
import { AlertService } from 'src/app/services/alert.service';
import { BookService } from 'src/app/services/book.service';
import { Company, ConfigService } from 'src/app/services/config.service';
import { HelpService } from 'src/app/services/help.service';
// import { TIPS_STEPS } from 'src/app/floating-tips/floating-tips.component';
import { ImagesCacheService } from 'src/app/services/images-cache.service';
import { PermissionService } from 'src/app/services/permission.service';
import { ReportService } from 'src/app/services/report.service';
import { StudiesService } from 'src/app/services/studies.service';
import { AnimationsComponent } from 'src/app/utils/animations/animations.component';
import { DownloadInstructionsComponent } from 'src/app/utils/download-instructions/download-instructions.component';
import { ShareStudyComponent } from 'src/app/utils/share-study/share-study.component';
import { SideOptionsDesktopComponent } from 'src/app/utils/side-options-desktop/side-options-desktop.component';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

import { TourService } from 'src/app/services/tour.service';
import { DownloadModalComponent } from 'src/app/utils/download-modal/download-modal.component';
import { CookieService } from 'ngx-cookie-service';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { VerticalHeaderComponent } from 'src/app/header/vertical-header/vertical-header.component';
import { InfoStudyComponent } from 'src/app/utils/info-study/info-study.component';
import { Study } from 'src/app/data/study';

import { Tab } from 'src/app/tabs/book-pdf-flipbook/book-pdf-flipbook-vertical/bottom-nav/tab.type';

@Component({
  selector: 'app-book-pdf-flipbook-landscape',
  templateUrl: './book-pdf-flipbook-landscape.component.html',
  styleUrls: ['./book-pdf-flipbook-landscape.component.css'],
  animations: [
    trigger('centerBook', [
      state('closed', style({ 'position': 'absolute', 'left': '50%', 'transform': 'translateX(-75%)' })),
      state('open', style({ 'position': 'absolute', 'left': '50%', 'transform': 'translateX(-50%)' })),
      state('openWithReport', style({ 'position': 'absolute', 'right': '0' })),
      state('closedEnd', style({ 'position': 'absolute', 'left': '50%', 'transform': 'translateX(-25%)' })),
      transition('closed <=> open', animate('600ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('closed <=> openWithReport', animate('600ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('openWithReport <=> open', animate('600ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('openWithReport <=> closedEnd', animate('600ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('closedEnd <=> open', animate('600ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('showReport', [
      state('hidden', style({ 'opacity': '0', 'position': 'absolute', 'left': '50%', 'transform': 'translateX(-50%)', 'z-index': '-1' })),
      state('visible', style({ 'opacity': '1', 'position': 'absolute', 'left': '5px', 'z-index': '100' })),
      transition('hidden <=> visible', animate('1000ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class BookPdfFlipbookLandscapeComponent implements OnInit, AfterViewInit {
  @Input() token!: string;

  locator: string = ' - ';
  bookStudies: Study[] = [];

  downloading: number | null = null;
  caducityTime: Date | null = null;
  // TIPS_STEPS = TIPS_STEPS;
  // tipsStep: TIPS_STEPS;
  BookPageType = BookPageType
  BookImageType = BookImageType
  showSpinner = false;
  showWindowingTool: boolean = true
  bodyScale = 1;

  previewSize: number = 650
  previewSizeW: number = 650
  previewLeft: number = 10

  // Display parameters
  pageHeight: number = 800
  rows: number = 4
  columns: number = 3
  numOfImages: number = 18
  flipbookLoading: boolean = false
  flipbookLoaded: boolean = false
  pageNumber: number = 0
  ignoreOpenPreview: boolean = false
  flipbookHeight: number = 100
  reportScroll: number[] = [0.0]
  currentPage: number = 0
  turning: boolean = false

  reportFontSize = 14;
  pdfZoom = 1;

  showProtocolMoreInfo = false;

  tourMode = 'none';

  visorOpen: boolean = false;

  menuOpened = false;

  /** Muestra el overlay de informe en modo móvil landscape */
  showMobileReportPanel = false;

  // ESTO ES PARA PORTAL MODEL DEMO
  expandedIndex = false;
  expandedDigitalBookIndex = false;
  closeTimeout: any;

  indexDigitalBook: any[] = [];
  indexMenuList: any[] = [];
  //-------------------------------

  environment = environment;

  get isShowingCover() {
    return this.currentPage == 0 || this.currentPage == 1;
  }

  get isShowingBackpage() {
    return this.currentPage == this.bookService.currentBook!.pages.length;
  }

  @ViewChildren(FloatingVisorComponent) viewers!: QueryList<FloatingVisorComponent>;
  @ViewChild(DownloadInstructionsComponent) downloadInstructionsModal!: DownloadInstructionsComponent;
  @ViewChild(AnimationsComponent) animations!: AnimationsComponent;
  @ViewChild(ShareStudyComponent) shareStudyModal!: ShareStudyComponent;
  @ViewChild(DownloadModalComponent) downloadModal!: DownloadModalComponent;
  @ViewChild(SideOptionsDesktopComponent) sideOptions!: SideOptionsDesktopComponent;
  @ViewChild(VerticalHeaderComponent) verticalHeaderComponent!: VerticalHeaderComponent;
  @ViewChild(InfoStudyComponent) infoStudyModal!: InfoStudyComponent;
  


  company!: Company;
  public Company = Company;
  TokenPermissions = TokenPermissions;
  window = window;

  //subscription: Subscription; // Observer para poder cambiar la visibilidad de componenetes desde el tour

  constructor(
    public tourService: TourService,
    public globalVariables: GlobalVariables,
    public bookService: BookService,
    public reportService: ReportService,
    public studiesService: StudiesService,
    private alertService: AlertService,
    private configService: ConfigService,
    public imagesService: ImagesCacheService,
    public permissionService: PermissionService,
    private helpService: HelpService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private _renderer2: Renderer2,
    private translate: TranslateService,
    private cookieService: CookieService,
    @Inject(DOCUMENT) private _document: Document) {
    // setInterval(() => {
    //   console.log('currentPage', this.currentPage);

    //   console.log('isShowingCover', this.isShowingCover);
    //   console.log('isShowingBackpage', this.isShowingBackpage);

    //   console.log('calculateCenterBookAnimation', this.calculateCenterBookAnimation());

    // }, 3000)

    // this.http.get('/assets/test/testReport.html', { responseType: 'text' }).subscribe(res => {
    //   console.log(res);
    //   this.loadedReport = this.sanitizer.bypassSecurityTrustHtml(res);
    // })

    // Sobreescribimos el método que abre los hipervínculos en los PDFs
    // if (typeof window !== 'undefined' && (window as any).pdfjsViewer) {
    //   (window as any).pdfjsViewer.PDFLinkService.prototype.goToDestination = (dest: any) => {
    //     console.log('dest', dest);
    //     return new Promise<void>((resolve, reject) => {
    //       console.log('dest', dest);
    //       this.goToImage(dest as string);
    //       resolve();
    //     });
    //   }
    // }


    // ESTO ES PARA PORTAL MODEL DEMO
    if (environment.demo) {

      this.http.get<any[]>(`assets/data/index-digital-book.json`, { responseType: 'json' }).subscribe({
        next: (res) => {

          console.log('_DITAL-BOOK-LIST', res);
          this.indexDigitalBook = res;

        },
        error: (err) => {
          console.error(err);
        }
      })
      this.http.get<any[]>(`assets/data/index-menu.json`, { responseType: 'json' }).subscribe({
        next: (res) => {

          console.log('index-menu', res);
          this.indexMenuList = res;

        },
        error: (err) => {
          console.error(err);
        }
      })
    }
  }

  onPdfLoaded(pdfViewerRef: PdfViewerComponent) {
    if (pdfViewerRef?.pdfLinkService) {
      pdfViewerRef.pdfLinkService.goToDestination = (dest: any) => {
        console.log('dest', dest);
        this.goToImage(dest as string);
        return Promise.resolve();
      };
    }
  }

  ngAfterViewInit(): void {

    this.tourService.deleteAllSteps(20);


    console.log("TourMode Type¿? --> ", this.tourService.tourMode);
    if (this.tourService.tourMode == "always") {
      setTimeout(() => {

        if (this.isPageSmall) {
          //this.tourService.initMobileTour();
          //this.startHorizontalMobileTour();
        } else {
          this.tourService.initDesktopTour();
          this.startDesktopTour();
        }
      }, 500);
    } else if (this.tourService.tourMode == "cookies") {
      if (!this.checkCookieTour()) {
        setTimeout(() => {

          if (this.isPageSmall) {
            //this.tourService.initMobileTour();
            //this.startHorizontalMobileTour();
          } else {
            this.tourService.initDesktopTour();
            this.startDesktopTour();
          }
        }, 500);

      }
    } else if (this.tourService.tourMode == "basic") {
      if (!this.checkCookieTour()) {
        setTimeout(() => {

          if (this.isPageSmall) {
            //this.headerComponent.isCollapsed = false;
            this.tourService.initMobileTour();
            //this.headerComponent.startBasicTour();
          } else {
            // if (this.permissionService.bookMode == 'prescriptor'){
            //   this.sideOptions.open();
            //   this.tourService.initDesktopTour();
            //   this.sideOptions.startBasicTour();
            // }
          }
        }, 500);

      }
    }
  }


  ngOnInit(): void {
    this.refreshReportZoom();

    // Cuando el visor esté abierto, prevenir el botón atrás y cerrar el visor
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', event => {
      if (this.viewers.some(v => v.isOpen)) {
        this.viewers.forEach(v => v.hide());
        history.pushState(null, document.title, location.href);
      } else {
        history.back();
      }
    });

    this.refreshCompany();

    // SCRIPTS PARA LLAMARLOS DESDE LOS HTML DE LOS INFORMES
    let script = this._renderer2.createElement('script');
    script.type = `text/javascript`;
    script.text = `
          function goToImage(uid) {
            const event = new CustomEvent("goToImage", { detail: uid });
            document.dispatchEvent(event);
          }
          function goToPage(page) {
            const event = new CustomEvent("goToPage", { detail: page });
            document.dispatchEvent(event);
          }
        `;

    this._renderer2.appendChild(this._document.body, script);

    // LISTENERS DE LOS EVENTOS LANZADOS POR LOS SCRIPTS DE LOS HTML INFORMES
    document.addEventListener("goToImage", (evt: Event) => {
      // console.log('UID: ', evt.detail);
      this.goToImage((evt as CustomEvent).detail);
    })
    document.addEventListener("goToPage", (evt: Event) => {
      // console.log('PAGE: ', evt.detail);
      this.goToPage((evt as CustomEvent).detail);
    })

  }

  refreshCompany() {
    this.company = this.configService.company;
    if (this.company == Company.NOT_DEFINED) {
      setTimeout(() => {
        this.refreshCompany();
      }, 200);
    }
  }

  public loadBook() {
    this.showSpinner = true;
    this.bookService.loadBookByToken(this.token).then(() => {
      this.showSpinner = false;
      this.bookService.startLoadingBook();
      this.flipbookLoading = true;
      setTimeout(() => {
        this.loadFlipbook();
        this.flipbookLoading = false;
        if (this.isPageSmall) {
          //this.animations.showFingerAnimation('horizontal')
        }
      }, 250);

      // this.tipsStep = TIPS_STEPS.NONE;
    })

    this.getBookStudies(this.token).then(sts => {
      this.bookStudies = sts;
    }).catch(() => {});

    this.bookService.getLocatorByToken(this.token).then(locator => {
      this.locator = locator;
    }).catch(error => {
      console.error(error);
    })

    this.bookService.checkExpiringTime(this.token).subscribe(time => {
      this.configService.getConfig().then(c => {
        this.caducityTime = new Date(time);
      })
    })
  }

  getBookStudies(token: string): Promise<Study[]> {
    
    return new Promise((resolve, reject) => {
      if(token != null && token != ""){
        this.studiesService.getStudiesByToken(token).then(studies => {
          resolve(studies);
        })
      }else{
        reject('No token provided');
      }
    })
  }

  loadFlipbook() {
    let bookRow = document.getElementById('bookRow')
    // let newHeight = 
    let newHeight = (this.isPageSmall) ? 4000 : (bookRow!.clientWidth / 2.9) * 4 / 3

    bookRow!.style.height = newHeight + 'px'

    let reportContainer = document.getElementById('reportContainer')
    if (reportContainer != null)
      reportContainer.style.height = newHeight + 'px'

    let wrapperEL = document.getElementById('wrapper')

    if (wrapperEL != null) {
      if ((wrapperEL.clientHeight - 20) / 0.75 > wrapperEL.clientWidth)
        this.pageHeight = (wrapperEL.clientHeight - 20) * 0.75
      else {
        this.pageHeight = (wrapperEL.clientHeight - 20)
      }
      //  this.flipbookHeight = wrapperEL.clientHeight * this.zoom

      this.previewSize = this.pageHeight - 50;
      this.previewSizeW = this.previewSize;
      this.previewLeft = (wrapperEL.clientHeight - 20) / 2 - this.previewSize / 2;

      ($("#flipbook") as any).turn({
        width: this.pageHeight / 0.75,
        height: this.pageHeight,
        autoCenter: false,
        duration: 1000,
        inclination: 30,
        when: {
          turned: (event: Event, page: number, view: any) => {
            this.ignoreOpenPreview = false
            if (!this.showSpinner) {
              this.turning = false
              this.pageNumber = page

              if ((this.pageNumber % 2) == 1) this.pageNumber -= 1

              let reportDivs = document.getElementsByClassName('reportDiv')

              for (let i = 0; i < reportDivs.length; i++)
                reportDivs.item(i)!.scroll(this.reportScroll[0], this.reportScroll[1])

              // Hacerle play a los vídeos que haya en pantalla
              try {
                const videos = document.getElementsByClassName('multiframe-video')
                if (videos != null && videos.length > 0)
                  for (let i = 0; i < videos.length; i++) {
                    (videos.item(i) as HTMLVideoElement).play();
                  }
              } catch (err) {
                console.error(err);
              }
            }
          },
          turning: (event: Event, page: number, view: any) => {
            if (page == 0 || page == 1) {
              this.sideOptions?.open()
            } else {
              this.sideOptions?.close()
            }

            let reportDivs = document.getElementsByClassName('reportDiv')

            for (let i = 0; i < reportDivs.length; i++) {
              let reportDiv = reportDivs.item(i) as HTMLElement

              if (page == 2)
                //this.hammerIt(reportDiv)

              this.reportScroll = [reportDiv!.scrollLeft, reportDiv!.scrollTop]
            }

            this.currentPage = page

            if (this.isShowingCover || this.isShowingBackpage) {
              this.turning = true
            }

            for (let i = 0; i < reportDivs.length; i++)
              reportDivs.item(i)!.scroll(this.reportScroll[0], this.reportScroll[1])

            this.ignoreOpenPreview = true
            let timerId = setTimeout(() => this.ignoreOpenPreview = false, 200)

            //llamada a tour.service
            this.tourService.checkTurn(this.currentPage);
          }
        }
      });

      this.resizeBook();

      ($("#flipbook") as any).css('position', 'absolute');
      ($("#flipbook") as any).css('left', '50%');
      ($("#flipbook") as any).css('transform', 'translateX(-75%)');

      // this.refreshGestures()

      this.flipbookLoaded = true;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.animations.cancelAnimations();

    let bookRow = document.getElementById('bookRow')
    let newHeight = (bookRow!.clientWidth / 2.9) * 4 / 3

    bookRow!.style.height = newHeight + 'px'

    let reportContainer = document.getElementById('reportContainer')
    if (reportContainer != null)
      reportContainer.style.height = newHeight + 'px'

    if (this.flipbookLoaded) {

      if (!this.flipbookLoading) {
        this.resizeBook();
      }

    } else {
      this.loadBook();
    }
  }

  public resizeBook() {
    let flipbookEL = document.getElementById('flipbook')
    let wrapperEL = document.getElementById('wrapper')

    if (flipbookEL != null && wrapperEL != null) {

      // Estas serán las medidas del book por defecto
      let height = wrapperEL.clientWidth * 0.7070707;
      // let height = wrapperEL.clientWidth * 0.7070707;
      let width = wrapperEL.clientWidth;

      // Pero si vemos que el book es más alto que la página, el alto será el de la página
      if (height > wrapperEL.clientHeight) {
        height = wrapperEL.clientHeight;
        width = wrapperEL.clientHeight * 1.41428
      }

      // flipbookEL.style.width = '';
      // flipbookEL.style.height = '';

      // if ((wrapperEL.clientHeight - 20) / 0.70707 > wrapperEL.clientWidth)
      //   this.pageHeight = (wrapperEL.clientHeight - 20) * 0.70707;
      // else
      //   this.pageHeight = (wrapperEL.clientHeight - 20);

      // if (wrapperEL.clientWidth < 991)
      //   this.pageHeight = wrapperEL.clientHeight;

      // this.previewSize = this.pageHeight - 50;

      // // let bookDigitalContainer = document.getElementById('book-digital-container');
      // this.previewLeft = (wrapperEL.clientHeight - 20) / 2 - this.previewSize / 2;

      // console.log("zoom", this.zoom, this.flipbookHeight);

      ($("#flipbook") as any).turn('size', width, height);
    }
  }

  calculateCenterBookAnimation() {
    if (this.isPageSmall) {
      if (this.isShowingCover) {
        return 'closed';
      } else if (this.isShowingBackpage) {
        return 'closedEnd';
      } else {
        return 'open';
      }

    } else {
      if (this.isShowingCover) {
        return 'closed';
      } else if (this.isShowingBackpage) {
        return 'closedEnd';
      } else if (this.reportService.reports.length == 0) {
        return 'open';
      } else {
        return 'openWithReport';
      }
      // return this.closed == 0 ? 'closed' : (this.closed == 1 ? 'open' : (this.closed == 3 ? 'open' : 'closedEnd'))
    }
  }

  calculateShowReportAnimation() {
    // if (this.reportImages == null || this.reportImages.length == 0) {
    //   return 'hidden';
    // }
    if (this.isPageSmall) {
      return 'hidden';
    } else {
      if (this.isShowingCover || this.isShowingBackpage/* || this.bookService.currentBook.reports.length == 0*/) {
        return 'hidden';
      } else {
        return 'visible';
      }
    }
  }

  increaseZoom() {
    if (this.reportService.actualReport?.type == 'png') {
      let moveExtra: boolean = this.flipbookHeight == 100
      this.flipbookHeight = (this.flipbookHeight > 400) ? 400 : this.flipbookHeight + 10

      let reportDivs = document.getElementsByClassName('reportDiv');
      // let reportDiv = document.getElementById('reportDiv')

      for (let i = 0; i < reportDivs.length; i++) {
        const reportDiv = reportDivs.item(i);

        if (moveExtra)
          setTimeout(() => {
            reportDiv!.scrollBy(reportDiv!.clientWidth * 0.05, reportDiv!.clientHeight * 0.05)
          }, 5);
        else
          reportDiv!.scrollBy(reportDiv!.clientWidth * 0.05, reportDiv!.clientHeight * 0.05)
      }
    }

    if (this.reportService.actualReport?.type == 'html') {
      this.reportFontSize = this.reportFontSize + 2; this.refreshReportZoom()
    }

    if (this.reportService.actualReport?.type == 'pdf') {
      if (this.pdfZoom < 3)
        this.pdfZoom += 0.1;
    }
  }

  decreaseZoom() {
    if (this.reportService.actualReport?.type == 'png') {
      this.flipbookHeight = (this.flipbookHeight <= 100) ? 100 : this.flipbookHeight - 10

      let reportDivs = document.getElementsByClassName('reportDiv');

      for (let i = 0; i < reportDivs.length; i++) {
        const reportDiv = reportDivs.item(i);
        reportDiv!.scrollBy(-reportDiv!.clientWidth * 0.05, -reportDiv!.clientHeight * 0.05)
      }
    }

    if (this.reportService.actualReport?.type == 'html') {
      this.reportFontSize = this.reportFontSize - 2; this.refreshReportZoom()
    }

    if (this.reportService.actualReport?.type == 'pdf') {
      if (this.pdfZoom > 0.5)
        this.pdfZoom -= 0.1;
    }
  }

  // @HostListener("wheel", ["$event"])
  // public onScroll(event: WheelEvent) {
  //   const path = getPathOfEvent(event);
  //   if (path.some(el => el?.id == 'reportContainer') || path.some(el => el?.classList?.contains('reportDiv'))) {
  //     if (event.deltaY > 0)
  //       this.decreaseZoom()
  //     else
  //       this.increaseZoom()

  //     event.preventDefault()
  //     event.stopPropagation()
  //     return false
  //   }
  // }

  public get isFlipbookLoaded() {
    return this.flipbookLoaded
  }

  get isReport(): boolean {
    if (this.bookService.currentBook == null || this.pageNumber == null) {
      return false;
    }
    if (this.bookService.currentBook?.pages[this.pageNumber]?.type == BookPageType.REPORT || this.bookService.currentBook?.pages[this.pageNumber - 1]?.type == BookPageType.REPORT) {
      return true;
    }
    return false;
  }

  get isPageSmall() {
    return this.globalVariables.isPageSmall;
  }

  get isAboutToExpire(): boolean {
    if (this.configService.config != null && this.caducityTime != null) {
      let cadMillis = this.configService.config.show_caducity_warning_days * 86400000;
      if ((this.caducityTime.getTime() - cadMillis) < new Date().getTime()) {
        return true;
      }
    }
    return false;
  }

  get bookName() {
    if (environment.bookNames && this.translate.currentLang == 'es') {
      switch (this.token) {
        case 'demoMR_ST':
          return 'Resonancia Magnética<br>Book Estático';
        case 'demoCT_ST':
          return 'Tomografía<br>Book Estático';
        case 'demoMG_ST':
          return 'Mamografía<br>Book Estático';
        case 'demoPET_ST':
          return 'PET<br>Book Estático';
        case 'demoCHECKUP':
          return 'Check Up<br>Book Estático';
        case 'demoMR_STPLUS':
          return 'Resonancia Magnética<br>Book Estático Mejorado';
        case 'demoCT_STPLUS':
          return 'Tomografía<br>Book Estático Mejorado';
        case 'demoMG_STPLUS':
          return 'Mamografía<br>Book Estático Mejorado';
        case 'demoCR_STPLUS':
          return 'Rayos<br>Book Estático Mejorado';
        case 'demoCT_D':
          return 'Tomografía<br>Book Dinámico';
        case 'demoMR_D':
          return 'Resonancia Magnética<br>Book Dinámico';
        case 'demo1':
          return 'Resonancia Magnética<br>Hipervínculo';
        default:
          return '';
      }
    } else {
      return '';
    }
  }

  download() {
    // if (this.downloading == null) {
    //   this.downloading = 0;
    //   this.bookService.downloadStudy(this.bookService.currentBook.studyUIDs).subscribe(event => {
    //     if (event.type == HttpEventType.DownloadProgress) {
    //       const percentage = (event.loaded / event.total) * 100
    //       console.log('percentage: ', percentage);
    //       this.downloading = Math.round(percentage)
    //     }

    //     if (event.type == HttpEventType.Response) {
    //       saveAs(event.body, "dicomdir.zip");
    //       this.downloading = null;
    //     }
    //   })
    // }
  }

  refreshCaducity() {
    this.bookService.renewExpirationDate(this.token).subscribe(n => {
      this.caducityTime = new Date(n);
      this.alertService.alert('Se ha extendido el tiempo de caducidad');
    })
  }

  openPreviewByUID(imageUID: string) {
    if (this.ignoreOpenPreview) return

    document.body.style.transform = "translate3d(0, 0, 0) " + "scale3d(1, 1, 1) ";
    document.body.style.webkitTransform = "translate3d(0, 0, 0) " + "scale3d(1, 1, 1) ";
    const viewerToUse = this.viewers.first;
    viewerToUse.activateAdvancedMode();
    this.showSpinner = true;

    viewerToUse.loadImage(this.bookService.currentBook!.studyUIDs.join(','), imageUID).then(() => {
      this.showSpinner = false;
    }).catch(error => {
      this.showSpinner = false;
      alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
    });
  }

  openPreview(image: BookImage, event?: MouseEvent) {
    this.visorOpen = true;
    if (this.ignoreOpenPreview) return

    document.body.style.transform = "translate3d(0, 0, 0) " + "scale3d(1, 1, 1) ";
    document.body.style.webkitTransform = "translate3d(0, 0, 0) " + "scale3d(1, 1, 1) ";

    // console.log('opening img: ', image);

    const viewerToUse = this.viewers.first;
    if (this.bookService.currentBook!.advancedVisor) {
      viewerToUse.activateAdvancedMode();
    }

    if (!this.isPageSmall) {
      // console.log(event);
      if (event != null) {
        this.previewLeft = event.clientX - (this.previewSize / 2);

        let wrapperEL = document.getElementById('flipbook');
        if (wrapperEL != null) {
          this.previewLeft = wrapperEL.offsetLeft + 20;
          this.previewSize = wrapperEL.clientHeight - 15;
          this.previewSizeW = wrapperEL.clientWidth - 15;
        }

      }


    }
    this.showSpinner = true;

    switch (image.type) {
      case BookImageType.SERIES:
        const serieImagesSeries = this.bookService.currentBook!.studyInfo.find(s =>
          s.files.some(f => f == image.dicomFile) ||
          s.files.some(f => f.split('\\')[f.split('\\').length - 1] == image.dicomFile) ||
          s.files.some(f => f.split('/')[f.split('/').length - 1] == image.dicomFile)
        );
        // const serieImagesSeries = this.bookService.currentBook.studyInfo.find(s => s.serie == image.seriesUID);
        const instancesSeries = serieImagesSeries!.files.map(img => {
          let filename = img.split('\\')[img.split('\\').length - 1];
          filename = filename.split('/')[filename.split('/').length - 1];
          const instanceUID = filename.substring(0, filename.length - 4)
          return instanceUID;
        });

        // TODO No estoy seguro de si aquí vale usar el join
        viewerToUse.loadSerie(this.bookService.currentBook!.studyUIDs.join(','), instancesSeries).then(() => {
          this.showSpinner = false;
        }).catch(error => {
          this.showSpinner = false;
          alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        });

        // TODO No estoy seguro de si aquí vale usar el join
        // viewerToUse.loadImageFromRoute(this.bookService.currentBook.studyUIDs.join(','), image.dicomFile).then(() => {
        //   this.showSpinner = false;
        //   // TODO No estoy seguro de si aquí vale usar el join
        //   viewerToUse.loadComplementaryImages(this.bookService.currentBook.studyUIDs.join(','), image.dicomFile);
        // }).catch(error => {
        //   this.showSpinner = false;
        //   alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        // });
        break;
      case BookImageType.CINE:
        const serieImagesCine = this.bookService.currentBook!.studyInfo.find(s =>
          s.files.some(f => f == image.dicomFile) ||
          s.files.some(f => f.split('\\')[f.split('\\').length - 1] == image.dicomFile) ||
          s.files.some(f => f.split('/')[f.split('/').length - 1] == image.dicomFile)
        );
        // const serieImagesCine = this.bookService.currentBook.studyInfo.find(s => s.serie == image.seriesUID);
        // console.log('image.dicomFile', image.dicomFile);
        // console.log('serieImages', serieImagesCine);

        const instancesCine = serieImagesCine!.files.map(img => {
          let filename = img.split('\\')[img.split('\\').length - 1];
          filename = filename.split('/')[filename.split('/').length - 1];
          const instanceUID = filename.substring(0, filename.length - 4)
          return instanceUID;
        });

        // TODO No estoy seguro de si aquí vale usar el join
        viewerToUse.loadSerie(this.bookService.currentBook!.studyUIDs.join(','), instancesCine).then(() => {
          viewerToUse.playClip();
          this.showSpinner = false;
        }).catch(error => {
          this.showSpinner = false;
          alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        });

        // // TODO No estoy seguro de si aquí vale usar el join
        // viewerToUse.loadImageFromRoute(this.bookService.currentBook.studyUIDs.join(','), image.dicomFile).then(() => {
        //   // TODO No estoy seguro de si aquí vale usar el join
        //   viewerToUse.loadComplementaryImages(this.bookService.currentBook.studyUIDs.join(','), image.dicomFile).then(res => {
        //     this.showSpinner = false;
        //     viewerToUse.playClip();
        //   }).catch(error => {
        //     this.showSpinner = false;
        //     alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        //   });
        // }).catch(error => {
        //   this.showSpinner = false;
        //   alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        // });
        break;
      case BookImageType.GRID:
        viewerToUse.setGrid(image.gridSettings!.grid.rows, image.gridSettings!.grid.columns);
        // TODO No estoy seguro de si aquí vale usar el join
        viewerToUse.loadGridImages(image.gridSettings!.grid, this.bookService.currentBook!.studyUIDs.join(','), image.gridSettings!.dicomFiles).then(res => {
          this.showSpinner = false;
        }).catch(error => {
          this.showSpinner = false;
          alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        });
        break;
      case BookImageType.UNIQUE:
      default:
        let filename = image.dicomFile!.split('\\')[image.dicomFile!.split('\\').length - 1];
        filename = filename.split('/')[filename.split('/').length - 1];
        console.log('filename', filename);
        const instanceUID = filename.substring(0, filename.length - 4)
        // TODO No estoy seguro de si aquí vale usar el join
        viewerToUse.loadImage(this.bookService.currentBook!.studyUIDs.join(','), instanceUID).then(() => {
          this.showSpinner = false;
        }).catch(error => {
          this.showSpinner = false;
          alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        });
        // TODO No estoy seguro de si aquí vale usar el join
        // viewerToUse.loadImageFromRoute(this.bookService.currentBook.studyUIDs.join(','), image.dicomFile).then(() => {
        //   this.showSpinner = false;
        // }).catch(error => {
        //   this.showSpinner = false;
        //   alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        // });
        break;
    }
  }

  showMenu() {
    this.visorOpen = false;
  }

  openDownloadModal() {
    this.downloadModal.open();
  }

  downloadStudy() {
    this.sideOptions.onClickDownload();
  }

  downloadReport() {

    this.studiesService.downloadReport(this.bookService.currentBook!.studyUIDs);

  }

  sendMail(mail: string) {
    if (!environment.demo) {
      if (this.configService._systemConfig?.prpSlave) {
        this.bookService.sendBookMailByPRP(mail, this.token).subscribe(res => {
          if (res) {
            this.alertService.alert('Correo enviado');
          } else {
            this.alertService.alert('Ha ocurrido un error al enviar el correo');
          }

        });
      } else {
        this.bookService.sendNotifToMail(mail, this.token).subscribe(res => {
          this.alertService.alert('Correo enviado');
          // alert('Correo enviado')
        });
      }

    }
  }

  // checkAskForSerieImg() {
  //   const viewerToUse = this.viewers.first;
  //   let route = this.imagesService.getRouteByImageId(viewerToUse.currentImage);
  //   this.configService.surrounding_images.then(surrounding => {
  //     if (viewerToUse.loadedImages - (viewerToUse.currentIndex + 1) < surrounding) {
  //       const target = this.bookService.getMoreImages('after', route);
  //       if (!this.imagesService.isLoaded(target)) {
  //         // TODO No estoy seguro de si aquí vale usar el join
  //         viewerToUse.loadOneMoreImage(this.bookService.currentBook.studyUIDs.join(','), target)
  //       }
  //     }
  //     if (viewerToUse.currentIndex < surrounding) {
  //       const target = this.bookService.getMoreImages('before', route);
  //       if (!this.imagesService.isLoaded(target)) {
  //         // TODO No estoy seguro de si aquí vale usar el join
  //         viewerToUse.loadOneMoreImage(this.bookService.currentBook.studyUIDs.join(','), target)
  //       }
  //     }
  //   })

  // }


  lastDeltaX = 0
  lastDeltaY = 0

  /*hammerIt(elm: HTMLElement) {
    const hammertime = new Hammer(elm, {});
    if (!this.isPageSmall) {
      hammertime.get('pinch').set({
        enable: true
      });
    }
    var posX = 0,
      posY = 0,
      last_scale = 1,
      last_posX = 0,
      last_posY = 0,
      max_pos_x = 0,
      max_pos_y = 0,
      transform = "",
      el = elm;

    if (!this.isPageSmall) {
      hammertime.on('doubletap pan pinch panend pinchend', (ev) => {

        if (el.id == 'externalReportDiv' || el.id == 'internalReportDiv') {
          if (ev.type == "pan") {
            this.reportScroll = [el.scrollLeft, el.scrollTop]

            this.reportScroll[0] -= ev.deltaX - this.lastDeltaX
            this.reportScroll[1] -= ev.deltaY - this.lastDeltaY

            this.lastDeltaX = ev.deltaX
            this.lastDeltaY = ev.deltaY

            let reportDivs = document.getElementsByClassName('reportDiv')

            for (let i = 0; i < reportDivs.length; i++) {
              reportDivs.item(i)!.scroll(this.reportScroll[0], this.reportScroll[1])
            }
          }
        }


        if (this.isPageSmall && !this.showSpinner) {
          const viewerToUse = this.viewers.first;
          if (!viewerToUse.isOpen) {
            if (ev.type == "doubletap") {
              transform =
                "translate3d(0, 0, 0) " +
                "scale3d(2, 2, 1) ";
              this.bodyScale = 2;
              last_scale = 2;
              try {
                if (window.getComputedStyle(el, null).getPropertyValue('-webkit-transform').toString() != "matrix(1, 0, 0, 1, 0, 0)") {
                  transform =
                    "translate3d(0, 0, 0) " +
                    "scale3d(1, 1, 1) ";
                  this.bodyScale = 1;
                  last_scale = 1;
                }
              } catch (err) { }
              el.style.webkitTransform = transform;
              transform = "";
            }

            //pan    
            if (this.bodyScale != 1) {
              posX = last_posX + ev.deltaX;
              posY = last_posY + ev.deltaY;
              max_pos_x = Math.ceil((this.bodyScale - 1) * el.clientWidth / 2);
              max_pos_y = Math.ceil((this.bodyScale - 1) * el.clientHeight / 2);
              if (posX > max_pos_x) {
                posX = max_pos_x;
              }
              if (posX < -max_pos_x) {
                posX = -max_pos_x;
              }
              if (posY > max_pos_y) {
                posY = max_pos_y;
              }
              if (posY < -max_pos_y) {
                posY = -max_pos_y;
              }
            }

            //pinch
            if (ev.type == "pinch") {
              this.bodyScale = Math.max(.999, Math.min(last_scale * (ev.scale), 5));
            }
            if (ev.type == "pinchend") {
              last_scale = this.bodyScale;
              $('.book-image-container').hide();
              setTimeout(function () { $('.book-image-container').show(); }, 1);
            }

            //panend
            if (ev.type == "panend") {
              last_posX = posX < max_pos_x ? posX : max_pos_x;
              last_posY = posY < max_pos_y ? posY : max_pos_y;
            }

            if (this.bodyScale != 1) {
              transform =
                "translate3d(" + posX + "px," + posY + "px, 0) " +
                "scale3d(" + this.bodyScale + ", " + this.bodyScale + ", 1)";
            }

            if (transform) {
              el.style.webkitTransform = transform;
            }
          }
        }

        ev.preventDefault()
        return false
      });
    }
  }*/

  /*public refreshGestures() {
    let flipbook = document.getElementById('flipbookContainer')
    const hamm = new Hammer(flipbook!);

    hamm.get('swipe').set({
      direction: Hammer.DIRECTION_ALL,
      threshold: 15,
      velocity: 0.7
    });
    hamm.on('swipe', (ev) => {
      if (!this.showSpinner) {

        if (!(this.viewers != null && this.viewers.first != null && this.viewers.first.isOpen) && this.flipbookLoaded) {
          if (ev.deltaX > 0)
            ($("#flipbook") as any).turn('previous')
          else if (ev.deltaX < 0)
            ($("#flipbook") as any).turn('next')
        }

        const currentPage = $('.carousel')[0]?.getElementsByClassName('active')[0];
        if (currentPage != null) {
          if (this.bodyScale <= 1.1) {
            if (ev.deltaX > 0) {
              if (!currentPage.classList.contains('first'))
                ($('.carousel') as any).carousel('prev')
            } else {
              if (!currentPage.classList.contains('last'))
                ($('.carousel') as any).carousel('next')
            }
          }
        }

      }
    })

    this.hammerIt(document.body);

    let reportContainer = document.getElementById('externalReportDiv')
    this.hammerIt(reportContainer!)
  }*/

  isReportTransparent(page: BookPage): boolean {
    if (this.isPageSmall) return false

    return false;
    // return page.type == BookPageType.REPORT
    //   && (this.closed == 1 || (this.closed == 3 && this.turning))
    //   && index == 1
  }

  resetDeltas() {
    this.lastDeltaX = 0
    this.lastDeltaY = 0
  }

  stopEvent(e: Event) {
    e.preventDefault()
    return false
  }

  /*
  openReport() {
    if (this.isPageSmall)
      this.showMobileReportPanel = true;
  }*/


  goToPage(page: number) {
    // console.log('currentPage', this.currentPage);

    const int = setInterval(() => {
      if (this.currentPage == page - 1 || this.currentPage == page) {
        clearInterval(int);
      } else {
        if (this.currentPage > page) {
          ($("#flipbook") as any).turn('previous');
        } else {
          ($("#flipbook") as any).turn('next');
        }
      }
    }, 250);
  }

  auxDemoPngFile: string[] = [];
  goToImage(uid: string) {

    let index = -1;
    let page = -1;

    this.bookService.currentBook!.pages.forEach((p, pIndex) => {
      const i = p.bookImages.findIndex(img => img.sopInstanceUID == uid)
      if (i != -1) {
        index = i;
        page = pIndex;
      }
    })

    if (index == -1 || page == -1) {
      this.openPreviewByUID(uid);
      // this.alertService.alert("No se ha podido encontrar la imagen en el Book");
      return;
    }

    // console.log('location', { index, page });
    // console.log('currentPage', this.currentPage);

    const fakeEvent = { clientX: 1070 };

    const targetPages = (page % 2 == 1) ? { min: page + 1, max: page + 2 } : { min: page, max: page + 1 }

    // console.log('targetPages', targetPages);

    const targetImg = this.bookService.currentBook!.pages[page].bookImages[index];
    const inter = setInterval(() => {
      if (this.currentPage == targetPages.min || this.currentPage == targetPages.max) {
        clearInterval(inter);
        setTimeout(() => {
          this.auxDemoPngFile = targetImg.pngFile;
          setTimeout(() => {
            this.auxDemoPngFile = [];
            setTimeout(() => {
              this.openPreview(targetImg, (fakeEvent as MouseEvent));
            }, 500);
          }, 750);
        }, 250);
      } else {
        if (this.currentPage > targetPages.max) {
          ($("#flipbook") as any).turn('previous');
        } else {
          ($("#flipbook") as any).turn('next');
        }
      }
    }, 250);

  }

  /*startHorizontalMobileTour() {
    ($("#flipbook") as any).turn("page", 1);

    console.log("Añadiendo pasos del tour movil horizontal");


    this.tourService.guideTour.addSteps([

      {
        id: "btn-1",
        attachTo: {
          element: "#flipbook > div:nth-child(1)",
          on: "left"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();

            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              ($("#flipbook") as any).turn("page", 2);
              setTimeout(() => {

              }, 100)
              //this.tourService.guideTour.next();

            }
          }
        ],
        text:
          '<p>Bienvenido, este es tu Book digital.</p>' +
          '<p>Pulsando en las esquinas o arrastrando, podrás abrir el libro como si fuese uno de papel</p>',
      },
      {
        id: "btn-2",
        attachTo: {
          element: "#flipbook",
          on: "right"
        },
        buttons: [
          {
            classes: 'tour-round-button tour-btn-list',
            text: "Omitir",
            action: () => {
              ($("#flipbook") as any).turn("page", 1);
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();
            }
          },
          {
            classes: 'tour-round-button tour-btn-list',
            text: "Atrás",
            action: () => {
              ($("#flipbook") as any).turn("page", 1);
              setTimeout(() => {
                this.tourService.guideTour.back();
              }, 200)

            }

          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              //this.headerComponent.isCollapsed = false;
              //this.headerComponent.addHorizontalMenuSteps();
              setTimeout(() => {
                this.tourService.guideTour.next();
              }, 200);
            }
          }
        ],
        text: "<p>Dentro del libro, tienes las diferentes imágenes estudio.</p>" +
          "<p>Podrás pulsarlas para acceder a un visor</p>",

      }

    ])

    console.log("Pasos añadidos, iniciando tour");
    setTimeout(() => {
      this.tourService.guideTour.start();
    }, 500)

  }*/

  startDesktopTour() {
    console.log("Añadiendo pasos del tour desktop");
    ($("#flipbook") as any).turn("page", 1);

    this.tourService.guideTour.addSteps([

      {
        id: "btn-1",
        attachTo: {
          element: ".report-container",
          on: "right"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();

            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              ($("#flipbook") as any).turn("page", 2);
              //this.tourService.guideTour.next();
            }
          }
        ],
        classes: "shepherd-text tour-container",
        text:
          '<p>Bienvenido, este es tu Book digital. En el se encuentra tu informe e imágenes del estudio.</p>' +
          '<p>Pulsando en las esquinas o arrastrando con el ratón, podrás abrir el libro como si fuese uno de papel</p>'
      },
      {
        id: "btn-2",
        attachTo: {

          element: "#bookRow",
          on: "top"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              ($("#flipbook") as any).turn("page", 1);
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              ($("#flipbook") as any).turn("page", 1);
              this.tourService.guideTour.back();
            }

          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              this.viewers.first.openVisor();
              this.viewers.first.addVisorSteps();
              setTimeout(() => {
                this.tourService.guideTour.next();
              }, 500);
            }
          }
        ],
        classes: "shepherd-text tour-container",
        canClickTarget: false,
        text: "</p>Dentro del Book, podemos visualizar:</p>" +
          '<p>A la izquierda <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed" style="margin-bottom:1px;"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg> El informe resultante del estudio</p>' +
          '<p>A la derecha <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed" style="margin-bottom:1px;"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg> Las imágenes del estudio. Puedes navegar por el libro y acceder a cada imagen individualmente pulsando sobre ella</p>'
      },
    ])


    console.log("Pasos añadidos, iniciando tour");
    this.tourService.guideTour.start();
  }

  addLastStep() {
    this.sideOptions.addLastStep();
  }


  checkCookieTour(): boolean {

    if (this.isPageSmall) {
      if (this.cookieService.get('cookieTourHorizontalMobile')) {
        console.log("Cookie movil horizontal encontrada");
        return true;
      } else {
        console.log("Cookie movil horizontal no encontrada, se procede a su creación");
        this.cookieService.set('cookieTourHorizontalMobile', 'cookieTourHorizontalMobile')
        return false;
      }
    } else {
      if (this.cookieService.get('cookieTourDesktop')) {
        console.log("Cookie movil horizontal encontrada");
        return true;
      } else {
        console.log("Cookie movil horizontal no encontrada, se procede a su creación");
        this.cookieService.set('cookieTourDesktop', 'cookieTourDesktop')
        return false;
      }
    }

  }

  refreshReportZoom() {
    document.documentElement.style.setProperty('--report-font-size', this.reportFontSize + 'px');
    document.documentElement.style.setProperty('--report-font-size-large', this.reportFontSize + 7 + 'px');
    document.documentElement.style.setProperty('--report-font-size-larger', this.reportFontSize + 9 + 'px');
    document.documentElement.style.setProperty('--report-font-size-small', this.reportFontSize - 2 + 'px');
    document.documentElement.style.setProperty('--report-font-size-smaller', this.reportFontSize - 4 + 'px');
  }


  // ESTO ES PARA PORTAL MODEL DEMO

  toggleDigitalBookIndex(): void {
    this.expandedDigitalBookIndex = true;
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
  }

  keepMenuOpen(): void {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
  }

  closeDigitalBookIndexWithDelay(): void {
    this.closeTimeout = setTimeout(() => {
      this.expandedDigitalBookIndex = false;
    }, 100);
  }

  redirectTo(url: string) {
    window.location.href = url;
  }

  toggleMenu(): void {
    this.menuOpened = !this.menuOpened;
  }

  closeMenu(): void {
    this.menuOpened = false;
  }

  openInfoModal() {
    this.infoStudyModal.openModal(this.locator, this.bookStudies, this.caducityTime);
  }

  openShareModal() {
    this.shareStudyModal.open(this.locator);
  }

  openAdvancedVisor(){

    let studyUID: string | null = null;
    if (this.bookService.currentBook!.studyUIDs[0] != null) {
      studyUID = this.bookService.currentBook!.studyUIDs[0];
    } else {
      studyUID = this.bookService.currentBook!.studyUIDs[0]
    }
    if (studyUID == null) {
      this.alertService.alert('No se ha encontrado el estudio. Por favor, póngase en contacto con el centro hospitalario');
      return;
    }
    
    this.openVisorWindow(studyUID, this.token);

  }

  async openVisorWindow(studyUID: string, tkn: string) {

    // Abrir la ventana de forma síncrona para que Safari no la bloquee.
    // Safari solo permite window.open() en el contexto directo del gesto del usuario;
    // cualquier llamada tras un await/promise es bloqueada por el popup blocker.
    const visorWindow = window.open('', 'Visor', 'toolbar=no,top=10,left=10,width=' + (screen.width - 50) + ',height=' + (screen.height - 100));

    try {
      const token = await this.bookService.askForToken(tkn);
      console.log('token recibido:', token);
      console.log('studyUID:', studyUID);
      this.configService.getConfig().then(c => {
        const route = c.visorRoute + `?sid=${studyUID}&ustkn=${token}`;
        console.log('route; ', route);
        if (visorWindow) {
          visorWindow.location.href = route;
        }
      })
      
    } catch (error) {
      if (visorWindow) {
        visorWindow.close();
      }
      console.error('Error obteniendo token temporal de acceso:', error);
      this.alertService.alert('Error al obtener el token temporal de acceso. Por favor, póngase en contacto con el centro hospitalario');
    }

    
  }

  openReportModal(tab: Tab) {
    if (tab === 'report')
      this.showMobileReportPanel = true;
  }
  


}

